import React from 'react';

import { Box } from '@stockx/ui';
import { NavBarInner } from '@app/shell/SiteHeader/shared/components/Header.styles';
import ContentMobile from '@app/shell/SiteHeader/Header/components/Content/components/ContentMobile';
import ContentTabletAndDesktop from '@app/shell/SiteHeader/Header/components/Content/components/ContentTabletAndDesktop';

const Bot = () => (
  <Box>
    <Box w="100%" display={{ base: 'block', md: 'none' }}>
      <NavBarInner data-component="MobileNavBarInner">
        <ContentMobile data-component="MobileHeaderWrapper" />
      </NavBarInner>
    </Box>
    <Box display={{ base: 'none', md: 'block ' }}>
      <NavBarInner data-component="MobileNavBarInner">
        <ContentTabletAndDesktop />
      </NavBarInner>
    </Box>
  </Box>
);

export default Bot;
